module.exports = __webpack_public_path__ + "img/media-folder-main.a1eb10a3.svg";